import styled from 'styled-components'
import { Theme } from 'styles/Themes'

interface IStyleProps {
  secondary?: boolean
  smallHeight?: boolean
}

export default styled.div<IStyleProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  max-width: 284px;
  // margin-top: 10px;
  input:focus ~ span {
    opacity: 1;
  }
  .password-icon {
    position: absolute;
    top: 13px;
    right: 13px;
    width: 13px;
    height: 13px;
    filter: ${Theme.icons.PRIMARY};
    @media only screen and (min-width: 1441px) {
      width: 14px;
      height: 14px;
    }
  }
  @media only screen and (min-width: 1441px) {
  }
`
